export const theme /*: PrismTheme */ = {
  plain: {
    color: "#fff",
    backgroundColor: "#041d3a",
  },
  styles: [
    {
      types: ["prolog", "constant", "builtin"],
      style: {
        color: "#439b73",
      },
    },
    {
      types: ["inserted", "function"],
      style: {
        color: "#439b73",
      },
    },
    {
      types: ["deleted"],
      style: {
        color: "rgb(255, 85, 85)",
      },
    },
    {
      types: ["changed"],
      style: {
        color: "rgb(255, 184, 108)",
      },
    },
    {
      types: ["punctuation", "symbol"],
      style: {
        color: "rgb(248, 248, 242)",
      },
    },
    {
      types: ["string", "char", "tag", "selector"],
      style: {
        color: "#1fa2ff",
      },
    },
    {
      types: ["keyword"],
      style: {
        color: "#fff",
        fontStyle: "italic",
      },
    },
    {
      types: ["comment"],
      style: {
        color: "#586f84",
      },
    },
    {
      types: ["attr-name"],
      style: {
        color: "rgb(241, 250, 140)",
      },
    },
    {
      types: ["operator"],
      style: {
        color: "#c02428",
      },
    },
    {
      types: ["single-quoted-string"],
      style: {
        color: "#1fa2ff",
      },
    }, {
      types: ["variable"],
      style: {
        color: "#fff",
      },
    },

  ],
}
  